import { Divider, Popover, Text } from '../atoms'
import { MESSAGE_KEYS } from '../../constants/messageKeys'
import { EMPTY_VALUE } from '../../constants/stringConstants'
import { ComponentTranslationContext } from '../../providers'
import { TextTypes } from '../../types'
import React, { ReactNode, useContext } from 'react'

interface XMorePopoverProps {
    listItems: ReactNode[]
    popoverTitle: ReactNode
    fallbackValue?: string
    moreItemsTranslationKey?: string
}

/**
 * Accepts a list of ReactNodes, if the list has the length of 1 the ReactNode will be returned.
 * If the list is longer than that, the first item will show with a (+ x items suffix)
 * and the other entries will show in a popover
 **/
export const XMorePopover = ({
    listItems,
    popoverTitle,
    fallbackValue = EMPTY_VALUE,
}: XMorePopoverProps): ReactNode => {
    const { getLabel } = useContext(ComponentTranslationContext)
    if (!listItems?.length) return fallbackValue
    if (listItems.length === 1) return listItems

    return (
        <Popover
            popoverContent={
                <div>
                    <Text type={TextTypes.HEADING_4}>{popoverTitle}</Text>
                    <Divider />
                    <ul>
                        {listItems.map((listItem) => (
                            <Text key={listItem?.toString()}>{listItem}</Text>
                        ))}
                    </ul>
                </div>
            }
        >
            {listItems?.[0]}
            {' + '}
            {getLabel(MESSAGE_KEYS.X_MORE, { amount: listItems.length - 1 })}
        </Popover>
    )
}
